import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["value", "isExpanded", "expandedPlaceholder", "collapsedPlaceholder", "debounceTime", "intl", "showAIToggleButton", "isQuickFind"],
  _excluded2 = ["actionSubjectId", "advancedSearchURL", "secondaryAdvancedSearchURL", "isLoading", "onNavigate"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { SearchInput, getInputSkeletonFocus, getInputSkeletonSelection, getInputSkeletonQuery, removeInputSkeletonState, getSessionItem, SEARCH_QUERY_KEY, EnlargedSearchInput } from '@atlassian/search-dialog';
import React, { Fragment, useCallback, Suspense } from 'react';
import { injectIntl } from 'react-intl-next';
import { KeyboardShortcut, KeyboardShortcutContainer } from './product-search-input.styled';
import { sha256Hash, TextEnteredHandler, useAnalytics } from '../analytics';
import { onAdvancedSearchSelected, onPreQueryScreenViewed, onNonDebouncedSearchTriggered, onXButtonClicked, Trigger } from '../analytics/events';
import { useSearchSessionId } from '../search-session-provider';
import { messages } from '../../messages';
import { mergeRefCallback } from '../../utils/merge-ref-callback';
import { useSessionUserInput } from '../../extensible/user-input-provider';
import { useDialogExpansionContext } from '../../extensible/dialog-expansion-context';
import { useProductContext } from '../../extensible/product-router';
import { useQuery } from '../../extensible/query-context';
import { usePersistRecentSearches } from '../../extensible/recent-searches/persist-recent-search';
import { useFeaturesContext } from '../../extensible/features-context/features-context';
var SearchAIPromptComponent = /*#__PURE__*/React.lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_@atlassian/search-ai/prompt" */'@atlassian/search-ai/prompt').then(function (_ref) {
    var SearchAIPrompt = _ref.SearchAIPrompt;
    return {
      default: SearchAIPrompt
    };
  });
});
var AskAIButton = function AskAIButton() {
  var _useQuery = useQuery(),
    query = _useQuery.query;
  var queryHash = sha256Hash(query);
  var _useProductContext = useProductContext(),
    getActiveProduct = _useProductContext.getActiveProduct;
  var activeProduct = getActiveProduct();
  var searchSessionId = useSearchSessionId();
  var _useSessionUserInput = useSessionUserInput(),
    showSearchAIDialog = _useSessionUserInput.showSearchAIDialog,
    toggleShowSearchAIDialog = _useSessionUserInput.toggleShowSearchAIDialog;
  var _useDialogExpansionCo = useDialogExpansionContext(),
    isExpanded = _useDialogExpansionCo.isExpanded;
  return !!(activeProduct !== null && activeProduct !== void 0 && activeProduct.aiSearchConfig) || !!showSearchAIDialog && isExpanded ? /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement(Fragment, null)
  }, /*#__PURE__*/React.createElement(SearchAIPromptComponent, {
    query: query,
    queryHash: queryHash,
    searchSessionId: searchSessionId,
    onToggleShowSearchAIDialog: toggleShowSearchAIDialog,
    source: "searchDialog"
  })) : null;
};
var getTooltipContent = function getTooltipContent(message) {
  return /*#__PURE__*/React.createElement(KeyboardShortcutContainer, null, message, /*#__PURE__*/React.createElement(KeyboardShortcut, null, '/'));
};

// Visible for testing.
export var BaseProductSearchInput = /*#__PURE__*/function (_React$Component) {
  _inherits(BaseProductSearchInput, _React$Component);
  var _super = _createSuper(BaseProductSearchInput);
  function BaseProductSearchInput() {
    var _this;
    _classCallCheck(this, BaseProductSearchInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "ref", null);
    _defineProperty(_assertThisInitialized(_this), "onInput", function (value) {
      if (value !== _this.props.value) {
        var _this$props$onInput, _this$props;
        _this.expand(Trigger.TEXT_ENTERED);
        (_this$props$onInput = (_this$props = _this.props).onInput) === null || _this$props$onInput === void 0 || _this$props$onInput.call(_this$props, value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "expand", function (trigger) {
      var _this$props2 = _this.props,
        isExpanded = _this$props2.isExpanded,
        onOpen = _this$props2.onOpen,
        preQueryScreenViewed = _this$props2.preQueryScreenViewed,
        searchSessionId = _this$props2.searchSessionId;
      if (!isExpanded) {
        onOpen();
        preQueryScreenViewed({
          searchSessionId: searchSessionId,
          trigger: trigger
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "close", function (e) {
      var _this$props3 = _this.props,
        isExpanded = _this$props3.isExpanded,
        onBack = _this$props3.onBack;
      if (isExpanded) {
        onBack === null || onBack === void 0 || onBack(e);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onInputClick", function () {
      setTimeout(function () {
        var _this$ref;
        return (_this$ref = _this.ref) === null || _this$ref === void 0 ? void 0 : _this$ref.focus();
      });
      _this.expand(Trigger.CLICK);
    });
    _defineProperty(_assertThisInitialized(_this), "onEnter", function (event) {
      var _this$props4 = _this.props,
        isExpanded = _this$props4.isExpanded,
        onEnter = _this$props4.onEnter;
      if (isExpanded) {
        onEnter === null || onEnter === void 0 || onEnter(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var _this$props$onClear, _this$props5;
      setTimeout(function () {
        var _this$ref2;
        return (_this$ref2 = _this.ref) === null || _this$ref2 === void 0 ? void 0 : _this$ref2.focus();
      });
      (_this$props$onClear = (_this$props5 = _this.props).onClear) === null || _this$props$onClear === void 0 || _this$props$onClear.call(_this$props5);
    });
    _defineProperty(_assertThisInitialized(_this), "onRef", mergeRefCallback(_this.props.forwardRef, function (ref) {
      _this.ref = ref;
    }));
    return _this;
  }
  _createClass(BaseProductSearchInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
        onInput = _this$props6.onInput,
        stickySearchEnabled = _this$props6.stickySearchEnabled;
      var skeletonFocused = getInputSkeletonFocus();
      var skeletonQuery = getInputSkeletonQuery();
      var _getInputSkeletonSele = getInputSkeletonSelection(),
        selectionStart = _getInputSkeletonSele.selectionStart,
        selectionEnd = _getInputSkeletonSele.selectionEnd,
        selectionDirection = _getInputSkeletonSele.selectionDirection;
      var stickySearchQuery = getSessionItem(SEARCH_QUERY_KEY) || '';
      if (skeletonFocused) {
        this.expand(Trigger.CLICK);
        onInput === null || onInput === void 0 || onInput(skeletonQuery);
        if (this.ref) {
          var _this$ref3;
          this.ref.value = skeletonQuery;
          this.ref.focus();
          (_this$ref3 = this.ref) === null || _this$ref3 === void 0 || _this$ref3.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
        }
      }
      removeInputSkeletonState();
      if (stickySearchEnabled && stickySearchQuery) {
        onInput === null || onInput === void 0 || onInput(stickySearchQuery);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
        value = _this$props7.value,
        isExpanded = _this$props7.isExpanded,
        expandedPlaceholder = _this$props7.expandedPlaceholder,
        collapsedPlaceholder = _this$props7.collapsedPlaceholder,
        debounceTime = _this$props7.debounceTime,
        intl = _this$props7.intl,
        showAIToggleButton = _this$props7.showAIToggleButton,
        isQuickFind = _this$props7.isQuickFind,
        rest = _objectWithoutProperties(_this$props7, _excluded);
      var placeholder = isExpanded ? expandedPlaceholder : collapsedPlaceholder;
      var tooltipContent = getTooltipContent(intl.formatMessage(messages.common_search_input_collapsed_placeholder));
      var SearchInputComponent = isQuickFind ? EnlargedSearchInput : SearchInput;
      return /*#__PURE__*/React.createElement(React.Fragment, null, isExpanded ? /*#__PURE__*/React.createElement(TextEnteredHandler, {
        query: value,
        debounceTime: debounceTime
      }) : null, /*#__PURE__*/React.createElement(SearchInputComponent, _extends({}, rest, {
        onClick: this.onInputClick,
        onInput: this.onInput,
        ref: this.onRef,
        isExpanded: isExpanded,
        placeholder: placeholder,
        value: value,
        onEnter: this.onEnter,
        onClear: this.onClear,
        toggleAISearchButton: showAIToggleButton ? /*#__PURE__*/React.createElement(AskAIButton, null) : undefined,
        tooltipContent: tooltipContent,
        exitSearchLabel: intl.formatMessage(messages.common_search_input_exit_button_label),
        clearSearchLabel: intl.formatMessage(messages.common_search_input_clear_button_label)
      })));
    }
  }]);
  return BaseProductSearchInput;
}(React.Component);
export var ProductSearchInputWithIntl = injectIntl(BaseProductSearchInput);
export var ProductSearchInput = function ProductSearchInput(props) {
  var _getActiveProduct, _getActiveProduct2, _getActiveProduct3, _useFeaturesContext$q;
  var _usePersistRecentSear = usePersistRecentSearches(),
    _usePersistRecentSear2 = _slicedToArray(_usePersistRecentSear, 2),
    _ignore = _usePersistRecentSear2[0],
    persistRecentSearchOnEnter = _usePersistRecentSear2[1];
  var actionSubjectId = props.actionSubjectId,
    advancedSearchURL = props.advancedSearchURL,
    secondaryAdvancedSearchURL = props.secondaryAdvancedSearchURL,
    isLoading = props.isLoading,
    onNavigate = props.onNavigate,
    rest = _objectWithoutProperties(props, _excluded2);
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  var searchSessionId = useSearchSessionId();
  var _useSessionUserInput2 = useSessionUserInput(),
    stickySearchEnabled = _useSessionUserInput2.stickySearchEnabled,
    query = _useSessionUserInput2.query,
    resetSearchSession = _useSessionUserInput2.resetSearchSession,
    showSearchAIDialog = _useSessionUserInput2.showSearchAIDialog;
  var _useDialogExpansionCo2 = useDialogExpansionContext(),
    allowChangeExpand = _useDialogExpansionCo2.allowChangeExpand;
  var _useProductContext2 = useProductContext(),
    getActiveProduct = _useProductContext2.getActiveProduct;
  var showSearchOnEnter = !!((_getActiveProduct = getActiveProduct()) !== null && _getActiveProduct !== void 0 && _getActiveProduct.showSearchOnEnter);
  var invokePostQuerySearchRef = (_getActiveProduct2 = getActiveProduct()) === null || _getActiveProduct2 === void 0 ? void 0 : _getActiveProduct2.invokePostQuerySearchRef;
  var aiSearchEnabled = !!((_getActiveProduct3 = getActiveProduct()) !== null && _getActiveProduct3 !== void 0 && _getActiveProduct3.aiSearchConfig) || !!showSearchAIDialog;
  var isQuickFind = (_useFeaturesContext$q = useFeaturesContext().quickFind) === null || _useFeaturesContext$q === void 0 ? void 0 : _useFeaturesContext$q.enabled;
  var onEnter = useCallback(function (event) {
    persistRecentSearchOnEnter(event);
    if (showSearchAIDialog) {
      return;
    }
    if (showSearchOnEnter && !(event !== null && event !== void 0 && event.shiftKey)) {
      if (invokePostQuerySearchRef) {
        fireAnalyticsEvent(onNonDebouncedSearchTriggered());
        invokePostQuerySearchRef.current();
      }
      return;
    }
    var modifierKeyPressed = navigator.userAgent.includes('Mac') ? event.metaKey : event.ctrlKey;
    fireAnalyticsEvent(onAdvancedSearchSelected({
      actionSubjectId: actionSubjectId,
      isLoading: isLoading,
      newTab: false,
      trigger: modifierKeyPressed ? Trigger.SHORTCUT_MODIFIED : Trigger.SHORTCUT
    }));
    if (stickySearchEnabled && advancedSearchURL) {
      resetSearchSession();
    }
    onNavigate(modifierKeyPressed && secondaryAdvancedSearchURL ? secondaryAdvancedSearchURL : advancedSearchURL, event);
  }, [persistRecentSearchOnEnter, showSearchAIDialog, showSearchOnEnter, fireAnalyticsEvent, actionSubjectId, isLoading, stickySearchEnabled, advancedSearchURL, onNavigate, secondaryAdvancedSearchURL, invokePostQuerySearchRef, resetSearchSession]);
  var onClear = useCallback(function () {
    fireAnalyticsEvent(onXButtonClicked({
      actionSubjectId: actionSubjectId,
      searchSessionId: searchSessionId
    }));
    resetSearchSession();
    allowChangeExpand(true);
  }, [fireAnalyticsEvent, actionSubjectId, searchSessionId, resetSearchSession, allowChangeExpand]);
  var onPreQueryScreenViewedCB = useCallback(function (preQueryProps) {
    return fireAnalyticsEvent(_objectSpread(_objectSpread({}, onPreQueryScreenViewed(preQueryProps)), {}, {
      actionSubject: actionSubjectId
    }));
  }, [fireAnalyticsEvent, actionSubjectId]);
  return /*#__PURE__*/React.createElement(ProductSearchInputWithIntl, _extends({}, rest, {
    onEnter: onEnter,
    searchSessionId: searchSessionId,
    preQueryScreenViewed: onPreQueryScreenViewedCB,
    onClear: onClear,
    showClearButton: stickySearchEnabled && query !== '',
    allowChangeExpand: allowChangeExpand,
    stickySearchEnabled: stickySearchEnabled,
    showSearchOnEnter: showSearchOnEnter,
    showAIToggleButton: aiSearchEnabled,
    isLoading: isLoading,
    onNavigate: onNavigate,
    isQuickFind: isQuickFind
  }));
};